<template>
  <Panel
    class="frequently-asked-questions-item"
    item-scope
    item-prop="mainEntity"
    item-type="https://schema.org/Question"
    :open="open"
    @toggled="handleToggle"
  >
    <template #title>
      <h3 class="frequently-asked-questions-item__title">
        <slot name="title" />
      </h3>
    </template>
    <template #default>
      <ItemContent>
        <slot />
      </ItemContent>
    </template>
  </Panel>
</template>

<script lang="ts" setup>
  import Panel from '@/shared/ui/expansionPanels/ExpansionPanel.vue';

  import ItemContent from './ItemContent.vue';

  export interface Props {
    /**
     * Item is open.
     */
    open?: boolean;
  }

  defineProps<Props>();

  defineSlots<{
    /**
     * Question text.
     */
    title(): unknown;

    /**
     * Answer block.
     */
    default(): unknown;
  }>();

  const emit = defineEmits<{
    /**
     * Sends an event when the item state is toggled.
     */
    toggle: [open: boolean];
  }>();

  const handleToggle = (open: boolean) => {
    emit('toggle', open);
  };
</script>

<style lang="scss" scoped>
  .frequently-asked-questions-item__title {
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
</style>
